module.exports = __webpack_public_path__ + "static/media/3.46aed3ce.jpg";